<template>
    <div class="dropdown" ref="dropdownMenu" @click="toggleDropdown">
        <button class="dropdown__current" v-bind:class="{ open : isOpen }" v-on:keyup.down.stop="focusNext" v-on:keyup.esc="toggleDropdown">
            Export
            <i class="icon-angle-down dropdown__icon" v-bind:class="{ open : isOpen }"></i>
        </button>
        <div class="dropdown__options" v-show="isOpen">
            <div class="dropdown__item" tabindex="0" @click.prevent="getCSV" v-on:keydown="stopScroll($event)" v-on:keyup.stop.prevent="keyEventManager($event)">
                CSV
                <i class="icon-file-o"></i>
            </div>
            <div class="dropdown__item" tabindex="0" @click.prevent="getPDF" v-on:keydown="stopScroll($event)" v-on:keyup.stop.prevent="keyEventManager($event)">
                PDF
                <i class="icon-file-pdf-o"></i>
            </div>
        </div>
        <export-loader :text="loaderText" v-show="showLoader" />
    </div>
</template>

<script>
import ExportLoader from "./ExportLoader";
import axios from 'axios';
import FilesExportApi from "../../api/filesExportApi.js"

export default {
  name: 'ExportDropdown',
  props: ['formData'],
  components: {
    ExportLoader
  },
  data() {
    return {
      isOpen: false,
      showLoader: false,
      loaderText: 'Loading...'
    }
  },
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
    getCSV() {
      this.isOpen = false;
      this.showLoader = true;
      axios.post("/umbraco/surface/api/getcsv", this.formData)
        .then(response => {
            var fileName = "export.csv";
            var type = "text/csv";
            var blob = new Blob([response.data], { type: type });
            if (navigator.msSaveBlob) {
                navigator.msSaveBlob(blob, fileName);
            }
            else {
                var a = document.createElement("a");
                a.style = "display: none";
                document.body.appendChild(a);
                a.href = window.URL.createObjectURL(blob);
                a.download = fileName;
                a.click();
                window.URL.revokeObjectURL(a.href);
                document.body.removeChild(a);
            }
        })
        .catch(error => console.log(error))
        .then(() => {
          this.showLoader = false;
        });
    },
    getPDF() {
      this.isOpen = false;
      this.showLoader = true;

      FilesExportApi.getPdf(this.formData).then(function(response) {
          var blob = new Blob([response.data], { type: "application/pdf" });
          var fileName = 'export.pdf';
          if (navigator.msSaveBlob) {
            navigator.msSaveBlob(blob, fileName);
          }
          else {
            var a = document.createElement("a");
            a.style = "display: none";
            document.body.appendChild(a);
            a.href = window.URL.createObjectURL(blob);
            a.download = fileName;
            a.click();
            window.URL.revokeObjectURL(a.href);
            document.body.removeChild(a);
          }
      })
      .catch(error => console.log(error))
      .then(() => {
        this.showLoader = false;
      });
    },
    documentClick(e) {
      let el = this.$refs.dropdownMenu;
      let target = e.target;
      if ((el !== target) && !el.contains(target)) {
        this.isOpen = false;
      }
      },

    focusNext: function () {
        var currentElement = document.activeElement;
        var children = this.$refs.dropdownMenu.querySelectorAll('[tabindex]:not([tabindex="-1"])');
        var currentIndex = this.getCurrentElementIndex(children, currentElement);

        var nextIndex = currentIndex + 1;
        if (nextIndex >= children.length) {
            nextIndex = 0;
        }

    var nextElement = children[nextIndex];
    nextElement.focus();
    },
    focusPrevious: function () {

        var currentElement = document.activeElement;
        var children = this.$refs.dropdownMenu.querySelectorAll('[tabindex]:not([tabindex="-1"])');
        var currentIndex = this.getCurrentElementIndex(children, currentElement);

        var nextIndex = currentIndex - 1;
        if (nextIndex < 0) {
            nextIndex = children.length - 1;
        }

        var previousElement = children[nextIndex];
        previousElement.focus();
    },
    getCurrentElementIndex: function (children, currentElement) {
        var i = children.length - 1;
        for (; i >= 0; i--) {
            if (currentElement == children[i]) {
                break;
            }
        }
        return i;
    },
    selectOption: function () {
        var selectednode = document.activeElement;
        selectednode.click();
    },

    keyEventManager: function (e) {
        switch (e.key) {
            case ('ArrowDown'): {
                this.focusNext();
                break;
            }
            case ('ArrowUp'): {
                this.focusPrevious();
                break;
            }
            case ('Enter'): {
                this.selectOption();
                break;
            }
            case ('Escape'): {
                this.toggleDropdown();
                break;
            }
            default: {
                break;
            }
        }
    },
    stopScroll: function (e) {
        e.preventDefault();
    }
  },
  created() {
    document.addEventListener('click', this.documentClick);
  },
  destroyed() {
    document.removeEventListener('click', this.documentClick);
  }
}
</script>

<style lang="scss" scoped>
  @import "src/scss/variables";

  .dropdown {
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
    position: relative;

    &__current {
        height: 40px;
        padding: 0 20px;
        border: 2px solid;
        border-radius: 5px;
        text-decoration: none;
    }

    &__icon {
      margin-left: 10px;
      transition: all 0.2s;
      &.open {
        position: relative;
        transform: rotate(180deg);
      }
    }
    &__options {
      position: absolute;
      bottom: -10px;
      right: -2px;
      transform: translateY(100%);
      border: 2px solid;
      border-radius: 5px;
      z-index: 100;
    }
    &__item {
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: $main-font;
      height: 40px;
      padding: 0 20px;
      text-decoration: none;
      transition: all 0.2s;

      i {
        margin-left: 10px;
      }
    }
  }

  .printing-anchor {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/partials/ExportDropdown.vue